var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-project-container"},[_c('h1',{staticClass:"d-flex flex-column flex-sm-row ma-0"},[_c('span',[_vm._v("next project")]),_c('v-icon',{staticClass:"ml-4"},[_vm._v("mdi-arrow-right")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }